// src/services/PotaParkJsonRepo.ts
import type { PotaParkType } from '@/types';
import { normalizeTimestamp } from '@/utils/dateAndTime';

const PotaParkJsonRepo = {
  fetchById(id: string): PotaParkType {
    const normalizedId = id.toUpperCase();
    const parks = window.parksData;
    if (!parks) {
      throw new Error('Parks data not available. Ensure static data is loaded.');
    }
    const park = parks.find((park) => park.id === normalizedId);
    if (!park) {
      throw new Error(`Park with ID ${id} not found.`);
    }
    return park;
  },
  lastUpdatedAt(): number {
    const parks = window.parksData;
    if (!parks) {
      throw new Error('Parks data not available. Ensure static data is loaded.');
    }
    const latestTimestamp = parks.reduce((max, p) => {
      const ts = normalizeTimestamp(p.updatedAt);
      return ts > max ? ts : max;
    }, 0);

    return latestTimestamp; // already ms-normalised
  },
};

export default PotaParkJsonRepo;